import * as z from 'zod'

// Disallowing "+" in email addresses to prevent multiple accounts with variations of the same base email.
// For example, "user+test@example.com" and "user@example.com" would be treated as distinct emails without this restriction.
export const emailSchema = z
  .string()
  .email({ message: 'Must be a valid email' })
  .refine((email) => !email.includes('+'), {
    message: "Must not contain a '+' character",
  })
